import React from 'react';

import { SimpleIcon } from './icon-utils';

export function WorkflowDoneSuccessIcon() {
  return (
    <SimpleIcon fill="none" height={32} viewBoxDimensions="0 0 33 32" width={33}>
      <rect
        height="31.2034"
        rx="15.05"
        stroke="#039855"
        strokeOpacity="0.2"
        strokeWidth="0.796552"
        width="30.1"
        x="1.45003"
        y="0.398268"
      />
      <rect
        height="24.2379"
        rx="12.119"
        stroke="#039855"
        strokeOpacity="0.7"
        strokeWidth="0.796552"
        width="24.2379"
        x="4.38119"
        y="3.88103"
      />
      <rect
        fill="#027A48"
        height="17.4483"
        rx="8.72414"
        stroke="#027A48"
        strokeWidth="0.758621"
        width="17.4483"
        x="7.77579"
        y="7.27586"
      />
      <path
        d="M20.3619 13.7143L15.8102 18.2857L13.7412 16.2078"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.21379"
      />
    </SimpleIcon>
  );
}
